interface SettingsToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  isDark: boolean;
  testId?: string;
}

export function SettingsToggle({
  checked,
  onChange,
  disabled = false,
  isDark,
  testId,
}: SettingsToggleProps) {
  return (
    <button
      data-testid={testId}
      onClick={() => onChange(!checked)}
      disabled={disabled}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
        checked
          ? isDark
            ? "bg-white"
            : "bg-gray-900"
          : isDark
            ? "bg-zinc-800"
            : "bg-gray-200"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full transition-transform ${
          checked ? "translate-x-6" : "translate-x-1"
        } ${isDark ? "bg-black" : "bg-white"}`}
      />
    </button>
  );
}
